<script>
import BackgroundIllustration from '@/components/BackgroundIllustration'
import WideIconTile from '@/components/WideIconTile'
import StoreNotificationElement from '@/components/StoreNotificationElement'
import ViewTitle from '@/components/ViewTitle'
import NotificationsServices from '@/services/notifications'
import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import StringUtils from '@/utils/stringUtils'
import LostPetsUtils from '@/utils/lostPetsUtils'
import LostPetsFrame from '@/frames/lostPetsFrame'
import StoreFrame from '@/frames/storeFrame'
import LostObjectsFrame from '@/frames/lostObjectsFrame'
import ReportsFrame from '@/frames/reportsFrame'

export default
{
    name: 'notifications',

    created ()
    {
        this.oldLastSeenNotification = JSON.parse(JSON.stringify(LocalStorageUtils.observables.lastNotificationSeen))

        const cityId = EnvironmentUtils.cityName

        NotificationsServices.fetchSentPushNotifications(cityId).then(notifications =>
        {
            this.$store.commit('notifications/setSentPushNotifications', notifications)
        })

        StoreFrame.initFrame(this.$store)
        ReportsFrame.initFrame(this.$store, 'pending')
        LostObjectsFrame.initFrame(this.$store)
        LostPetsFrame.initFrame(this.$store)
    },

    render () 
    {
        const createPushNotificationCard = notification =>
        {
            const isRead = this.oldLastSeenNotification && notification.date <= this.oldLastSeenNotification.element.date
            
            return <wide-icon-tile title={notification.title} subtitle={notification.content} class={`${isRead ? 'read' : ''}`}
                icon={require('@/assets/img/speaker.svg')} inlineSvg={true} right-content={false} />
        }

        const createActualityCard = actuality =>
        {
            const isRead = this.oldLastSeenNotification && actuality.date <= this.oldLastSeenNotification.element.date
            
            return <wide-icon-tile title={actuality.title} class={`${isRead ? 'read' : ''}`}
                icon={require('@/assets/img/newspaper-icon.svg')} inlineSvg={true}
                on-click={() => this.$router.push('/actualities/' + actuality.id)} />
        }
        
        const createEventCard = event =>
        {
            const isRead = this.oldLastSeenNotification && event.date <= this.oldLastSeenNotification.element.date
            
            return <wide-icon-tile title= {StringUtils.removeHtmlTags(event.title)} class={`${isRead ? 'read' : ''}`}
                icon={require('@/assets/img/calendar-icon.svg')} inlineSvg={true}
                on-click={() => this.$router.push('/events')} />
        }
        
        const createReportCard = report =>
        {
            const tags = report.tags.map(t => <span class='tag'>{(this.reportTags.find(tag => tag.id == t) || {}).name}</span>)
            const subtitle = <div>Signalement n°{report.id} : {report.reason} {tags}</div>

            return <wide-icon-tile title='Nouveau signalement' subtitle={subtitle} class={`${!report.tags.includes('pending') ? 'read' : ''}`}
                on-click={() => this.$router.push('/edit/reports?id=' + report.id)} icon={require('@/assets/img/danger.svg')} inlineSvg={true} />
        }

        const createLostObjectCard = object =>
        {
            const tags = object.tags.map(t => <span class='tag'>{(this.lostObjectTags.find(tag => tag.id == t) || {}).name}</span>)
            const objState = object.tags.includes('found') ? 'trouvé' : 'perdu'
            const subtitle = <div>Objet n°{object.id} déclaré comme {objState} {tags}</div>
            const isPublishedView = !this.$store.state.user.privileges.canManageLostObjects

            if (isPublishedView)
            {
                const isRead = this.oldLastSeenNotification && object.date <= this.oldLastSeenNotification.element.date
                
                return <wide-icon-tile title={'Nouvel objet ' + objState + ' publié'} class={`${isRead ? 'read' : ''}`}
                    on-click={() => this.$router.push('/lost-objects?id=' + object.id)} icon={require('@/assets/img/question-mark.svg')} inlineSvg={true} />
            }

            return <wide-icon-tile title='Nouvel objet signalé' subtitle={subtitle} class={`${object.tags.includes('resolved') ? 'read' : ''}`}
                on-click={() => this.$router.push('/edit/lost-objects?id=' + object.id)} icon={require('@/assets/img/question-mark.svg')} inlineSvg={true} />
        }

        const createLostPetCard = pet =>
        {
            const tags = pet.tags.map(t => <span class='tag'>{(this.lostPetTags.find(tag => tag.id == t) || {}).name}</span>)
            const petState = LostPetsUtils.tagsToStateString(pet.tags)
            const subtitle = <div>Animal n°{pet.id} déclaré comme {petState} {tags}</div>
            const isPublishedView = !this.$store.state.user.privileges.canManageLostPets

            if (isPublishedView)
            {
                const isRead = this.oldLastSeenNotification && pet.date <= this.oldLastSeenNotification.element.date
                
                return <wide-icon-tile title={'Nouvel animal ' + petState + ' publié'} class={`${isRead ? 'read' : ''}`}
                    on-click={() => this.$router.push('/lost-pets?id=' + pet.id)} icon={require('@/assets/img/girl-with-pet.png')} />
            }

            return <wide-icon-tile title='Nouvel animal signalé' subtitle={subtitle} class={`${pet.tags.includes('resolved') ? 'read' : ''}`}
                on-click={() => this.$router.push('/edit/lost-pets?id=' + pet.id)} icon={require('@/assets/img/girl-with-pet.png')} />
        }

        const createStoreNotificationCard = notif =>
        {
            const isRead = this.oldLastSeenNotification && notif.date <= this.oldLastSeenNotification.element.date

            return <store-notification-element notification-id={notif.id} class={`${isRead ? 'read' : ''}`}
                on-click={() => this.$router.push('/stores/' + notif.storeId + '#notification-' + notif.id)} />
        }

        return (
            <div id='notifications-view'>
                <view-title>Dernières notifications</view-title>
                <background-illustration v-show={Object.keys(this.notificationsByDate).length == 0} image={require('@/assets/img/wind-blowing-leaves.svg')} 
                    message={'Aucune nouvelle notification.\nLes prochaines notifications que vous receverez apparaîtront ici.'} />
                
                <div id='notifications-list'>
                {
                    Object.keys(this.notificationsByDate).map(date =>
                    (
                        <div>
                            <div class='notification-date'>
                                { new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date(date)) }
                            </div>
                            {
                                this.notificationsByDate[date].map(e =>
                                {
                                    switch (e.type)
                                    {
                                        case 'push': return createPushNotificationCard(e.element)
                                        case 'report': return createReportCard(e.element)
                                        case 'lostObject': return createLostObjectCard(e.element)
                                        case 'lostPet': return createLostPetCard(e.element)
                                        case 'actuality': return createActualityCard(e.element)
                                        case 'event': return createEventCard(e.element)
                                        case 'storeNotification': return createStoreNotificationCard(e.element)
                                    }
                                })
                            }
                        </div>
                    ))
                }
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            oldLastSeenNotification: {}
        }
    },

    computed:
    {
        notificationsByDate ()
        {
            return this.$store.getters.notifications.notificationsByDate
        },

        reportTags ()
        {
            return this.$store.state.reports.tags
        },

        lostObjectTags ()
        {
            return this.$store.state.lostObjects.tags
        },

        lostPetTags ()
        {
            return this.$store.state.lostPets.tags
        }
    },

    methods:
    {
        // ..
    },

    components:
    {
        BackgroundIllustration,
        WideIconTile,
        StoreNotificationElement,
        ViewTitle
    }
}
</script>

<style scoped lang='less'>
@import '~@/styles/main.less';

#notifications-view
{
    margin-top: 12vw;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 4vh);
    margin-left: 5vw;
    margin-right: 5vw;

    .OnDesktop({
        margin-left: 15vw;
        margin-top: 4vw;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    #notifications-list
    {
        .OnDesktop({ margin-right: 10vw; });
        .OnLarge({ margin-right: 30vw; });

        .notification-date
        {
            color: var(--theme-background-text-color-heavy);
            margin-bottom: 10px;
            margin-top: 20px;
            font-size: 3.5vw;

            .OnTablet({ font-size: 2vw });
            .OnDesktop({ font-size: 1.5vh });

            .CapitalizeFirstLetter();
        }

        .wide-icon-tile
        {
            cursor: pointer;
            
            &.read:not(:hover)
            {
                background-color: var(--theme-border-color-light);
                box-shadow: none;
            }

            .row
            {
                display: flex;
                flex-direction: row;
                align-items: center;
            }


            .tag
            {
                padding: 3px 5px;
                background-color: var(--theme-background-color);
                border-radius: 5px;
                font-weight: 500;
                margin-left: 3px;
                white-space: nowrap;
                line-height: 25px;

                display: none;
                .OnDesktop({display: revert;});
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Notifications.vue